/**
 * Database table names used for the assets feature.
 *
 * @readonly
 * @enum {string}
 */
export const ASSETS_TABLES = {
  ASSETS: 'assets',
};

/**
 * User groups related to Assets with their respective identifiers.
 *
 * @enum {string}
 */
export const ASSETS_GROUPS = {
  ADMIN: 'assetadmin',
  VIEWER: 'assetviewer',
};

/**
 * Defines the colour codes used to visually represent different asset statuses.
 *
 * @enum {string}
 */
export const STATUS_COLORS = {
  pending: '#FFB74D',
  assigned: '#70CA44',
  archived: '#E57373',
  inventory: '#BDBDBD',
};
